// extracted by mini-css-extract-plugin
module.exports = {"modalSubtitles":"CreateRequestModal_modalSubtitles__2QV3v","modalLastRowInSection":"CreateRequestModal_modalLastRowInSection__18ACl"};